// extracted by mini-css-extract-plugin
module.exports = {"h1Class":"H1_h1Class__2GoFI"};